<template>
  <div class="czzn-zbcx">
    <div class="czsc-con">
      <div class="czsc-nr-tit">【总账】</div>
      <p>总账即总分类账，用于查询总账的账务数据，查询总账科目的本期借方发生额、本期贷方发生额、本年借方累计、本年贷方累计、期初余额、期末余额等项目总账数据。</p>
      <img src="@/assets/images/czzn_040.png" />
      <p>具体操作：</p>
      <p>步骤 1  在工作台中，将鼠标放在“账表查询”模块，点击“总账”，进入“总账”页面。</p>
      <p>步骤 2  在“总账”页面中，您可以执行以下操作：</p>
      <div class="czsc-nr-ct-box">如何查询总账</div>
      <p>将鼠标放在“更多条件”处，点击设置更多查询条件。</p>
      <p>[会计期间]：默认当前会计期间，可设置查询的开始会计期间和结束会计期间。</p>
      <p>[会计科目]：右侧为会计科目导航，可查看所需科目的总账，也可点击“更多条件”设置查询的起始科目和结束科目，将会查询该范围内的所有科目的总账。</p>
      <p>[科目级次]：设置科目的级次。</p>
      <p>设置好查询条件后，点击“确定”按钮，页面将显示符合条件的查询结果。</p>
      <div class="czsc-nr-ct-box">如何查看明细账</div>
      <p>在查询结果列表中，双击“总账表体”，可以查看对应科目的明细账。</p>
      <div class="czsc-nr-ct-box">如何打印总账</div>
      <p>在总账列表中，点击“打印”或“连续打印”按钮，进入“总账打印”设置页面。打印方式为 PDF 打印。</p>
      <div class="czsc-nr-ct-box">如何导出总账</div>
      <p>在总账列表中，点击“导出”按钮，在左下方出现 Excel 表格，可以直接打开查看或者保存至本地。</p>
      <div class="czsc-nr-tit">【明细账】</div>
      <p>明细账是指明细科目开设的账户，对分类账的经济内容进行明细分类核算，提供具体而  详细的核算资料。</p>
      <p>平台提供明细账的查询功能，对每一科目在不同期间的余额和发生额进行统计显示。</p>
      <img src="@/assets/images/czzn_041.png" />
      <p>具体操作：</p>
      <p>步骤 1  在工作台中，将鼠标放在“账表查询”模块，点击“明细账”，进入“明细账”页面。</p>
      <p>步骤 2 在“明细账”页面中，您可以执行以下操作：</p>
      <div class="czsc-nr-ct-box">如何查询明细账</div>
      <p>将鼠标放在“更多条件”处，点击设置更多查询条件。</p>
      <p>[会计期间]：默认当前会计期间，可设置查询的开始会计期间和结束会计期间。</p>
      <p>[会计科目]：设置查询的起始科目和结束科目，将会查询该范围内的所有科目的明细账。</p>
      <p>[科目级次]：设置科目的级次。</p>
      <p>[显示辅助核算]：勾选显示辅助核算后，将会显示出设置过辅助核算的科目，可以精确查询每个核算项目。</p>
      <p>[只显示最明细科目]：勾选该选项后，查询结果显示的只是最明细科目。</p>
      <p>[余额为0不显示]：勾选该选项后，查询结果中余额为0的科目将不显示。</p>
      <p>[无发生额不显示]：勾选该选项后，本年度包括期初无任何发生的科目将不显示。</p>
      <div class="czsc-nr-hsbj-box">
        <p>说明：</p>
        <p>“明细账”页面右侧一栏显示的是当前会计年份中有发生额的科目。</p>
        <p>设置好查询条件后，点击“确定”按钮，页面将显示符合条件的查询结果。</p>
      </div>
      <div class="czsc-nr-ct-box">明细账联查凭证</div>
      <p>在明细账列表中，双击“凭证字号”链接，可以查看和修改凭证。</p>
      <div class="czsc-nr-ct-box">如何打印明细账</div>
      <p>在明细账列表中，点击“打印”按钮，进入“明细账打印”设置页面。打印方式为 PDF打印，如果您希望打印当前会计年份中所有有发生额的科目，可以点击“连续打印”按钮。</p>
      <div class="czsc-nr-ct-box">如何导出明细账</div>
      <p>在明细账列表中，点击“导出”按钮，在左下方出现 Excel 表格，可以直接打开查看或者保存至本地。</p>
      <div class="czsc-nr-tit">【数量金额总账】</div>
      <p>平台提供数量金额总账的查询功能，对所选科目在在不同期间的数量、单价及发生额进  行统计显示，并提供联查到数量金额明细账的功能。</p>
      <img src="@/assets/images/czzn_042.png" />
      <p>具体操作：</p>
      <p>步骤 1  在工作台中，将鼠标放在“账表查询”模块，点击“数量金额总账”，进入“数量金额总账”页面。</p>
      <p>步骤 2  在“数量金额总账”页面中，您可以执行以下操作：</p>
      <div class="czsc-nr-ct-box">如何查询数量金额总账</div>
      <p>将鼠标放在“更多条件”处，点击设置更多查询条件。</p>
      <p>[会计期间]：设置查询的开始会计期间和结束会计期间。</p>
      <p>[会计科目]：设置查询的起始科目和结束科目，默认为空，即查询所有科目的数量金额总账。</p>
      <p>[科目级次]：设置科目的级次。</p>
      <p>[显示辅助核算]：选中表示在数量金额总账中显示核算项目的数量金额总账。</p>
      <p>点击“确定”按钮，页面显示符合条件的查询结果。</p>
      <div class="czsc-nr-ct-box">如何查看数量金额明细账</div>
      <p>在数量金额总账列表中，点击“表体区域”链接，即可查看数量金额明细账。</p>
      <div class="czsc-nr-ct-box">如何打印数量金额总账</div>
      <p>在数量金额总账页面，点击“ 打印”按钮，进入“数量金额总账”打印设置页面。</p>
      <div class="czsc-nr-ct-box">如何导出数量金额总账</div>
      <p>页面显示查询结果后，点击击“导出”按钮，左下方出现 Excel 表格，直接打开查看或者保存至本地。</p>
      <div class="czsc-nr-tit">【数量金额明细账】</div>
      <p>平台提供数量金额明细账的查询功能，统计显示出数量金额核算科目在不同期间的数量、单价及发生额。数量金额明细账适用于既需要提供数量信息，又需要提供金额信息的业务查询。</p>
      <img src="@/assets/images/czzn_043.png" />
      <p>具体操作：</p>
      <p>步骤 1 在工作台中，将鼠标放在“账表查询”模块，点击“数量金额明细账”，进入“数量金额明细账”页面。</p>
      <p>步骤 2 在“数量金额明细账”页面中，您可以执行以下操作：</p>
      <div class="czsc-nr-ct-box">如何查询数量金额明细账</div>
      <p>将鼠标放在“更多条件”处，点击设置更多查询条件。</p>
      <p>[会计期间]：设置查询的开始会计期间和结束会计期间。</p>
      <p>[会计科目]：设置查询的起始科目和结束科目，默认为空，即查询所有科目的数量金额明细账。</p>
      <p>[科目级次]：设置科目的级次。</p>
      <p>[显示辅助核算]：选中表示在数量金额明细账中显示核算项目的数量金额明细账。  点击“确定”按钮，页面显示符合条件的查询结果。</p>
      <div class="czsc-nr-ct-box">如何查看凭证</div>
      <p>在数量金额明细账列表中，点击“凭证字号”链接，即可查看或修改凭证。</p>
      <div class="czsc-nr-ct-box">如何打印数量金额明细账</div>
      <p>在数量金额明细账页面，点击“ 打印”按钮，进入“数量金额明细账”打印设置页面。如果您想打印所有的数量金额明细账，可以点击“连续打印”按钮。</p>
      <div class="czsc-nr-ct-box">如何导出数量金额明细账</div>
      <p>页面显示查询结果后，点击“导出”按钮，左下方出现 Excel 表格，直接打开查看或者保存至本地。</p>
      <div class="czsc-nr-tit">【凭证汇总表】</div>
      <p>凭证汇总表是将记账凭证按照指定的范围和条件汇总其一级科目的借贷方发生额。按不同条件对会计凭证进行汇总，可以提供各种所需的会计信息。</p>
      <img src="@/assets/images/czzn_044.png" />
      <p>具体操作：</p>
      <p>步骤 1 在工作台中，将鼠标放在“账表查询”模块，点击“凭证汇总表”，进入“凭证汇总表”页面。</p>
      <p>步骤 2 在“凭证汇总表”页面中，您可以执行“多条件查询”、“打印”“导出”操作。</p>
      <div class="czsc-nr-tit">【科目余额表】</div>
      <p>根据记账凭证，生成某会计期间内各科目的期初余额、借方发生额、贷方发生额及期末余额。</p>
      <img src="@/assets/images/czzn_045.png" />
      <p>具体操作：</p>
      <p>步骤 1 在工作台中，将鼠标放在“账表查询”模块，点击“科目余额表”，进入“科目余额表”页面。</p>
      <p>步骤 2 在“科目余额表”页面中，您可以执行“多条件查询”、“打印”“导出”操作。</p>
      <div class="czsc-nr-tit">【试算平衡表】</div>
      <p>试算平衡表用于输出和查询所选期间的各科目的期初余额、本期发生额、期末余额的数据。用户可以查询不同的会计期间的试算平衡表数据。</p>
      <img src="@/assets/images/czzn_046.png" />
      <p>具体操作：</p>
      <p>步骤 1 在工作台中，将鼠标放在“账表查询”模块，点击“试算平衡表”，进入“试算平衡表”页面。</p>
      <p>步骤 2 在“试算平衡表”页面中，您可以执行“多条件查询”、“打印”“导出”操作。</p>
      <div class="czsc-nr-tit">【辅助项目余额表】</div>
      <p>辅助核算项目余额表用于反映一定时期内所发生业务的期初余额、本期借、贷方发生额、及期末余额，帮助用户进行核算项目余额的分析。</p>
      <img src="@/assets/images/czzn_047.png" />
      <p>具体操作：</p>
      <p>步骤 1 在工作台中，将鼠标放在“账表查询”模块，点击“辅助项目余额表”，进入“辅助项目余额表”页面。</p>
      <p>步骤 2 在“辅助项目余额表”页面中，您可以执行“多条件查询”、“打印”“导出”操作。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'czzn_zbcx',
};
</script>
